import { useMemo, useSyncExternalStore } from 'react';

/**
 * Subscribe a uma media query CSS. Retorna `true` se matches.
 * SSR-safe: retorna `false` no servidor via `getServerSnapshot`.
 *
 * @example
 *   const isMobile = useMediaQuery('(max-width: 768px)');
 */
export function useMediaQuery(query: string): boolean {
  const [subscribe, getSnapshot] = useMemo(() => {
    const mql = window.matchMedia(query);
    return [
      (callback: () => void) => {
        mql.addEventListener('change', callback);
        return () => mql.removeEventListener('change', callback);
      },
      () => mql.matches,
    ] as const;
  }, [query]);

  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
